module.exports = require("@angular/animations");


//////////////////
// WEBPACK FOOTER
// external "@angular/animations"
// module id = 51
// module chunks = 0